import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { buildMuiTheme } from './muiTheme';

const ThemeCtx = createContext({
  theme: 'light',
  toggleTheme: () => {},
  setTheme: () => {},
});

export function ThemeProvider({ children }) {
  // NOTE: Light mode is hardcoded for now. To re-enable dark mode / user preference,
  // restore the commented initializer below and remove the hardcoded 'light' value.
  const [theme, setTheme] = useState('light');
  // const [theme, setTheme] = useState(() => {
  //   try {
  //     const stored = localStorage.getItem('bv-theme');
  //     if (stored === 'light' || stored === 'dark') {
  //       return stored;
  //     }
  //     if (typeof window !== 'undefined' && window.matchMedia) {
  //       return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  //     }
  //   } catch (e) {
  //     // ignore local storage / matchMedia errors
  //   }
  //   return 'light';
  // });

  useEffect(() => {
    try {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('bv-theme', theme);
    } catch (e) {
      // ignore
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const muiTheme = useMemo(() => buildMuiTheme(theme), [theme]);

  const contextValue = useMemo(
    () => ({
      theme,
      toggleTheme,
      setTheme,
    }),
    [theme]
  );

  return (
    <ThemeCtx.Provider value={contextValue}>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
export default ThemeProvider;
